(() => {
  function setup(section) {
    const root = section.matches?.('[data-product-details]') ? section : section.querySelector?.('[data-product-details]');
    if (!root || root.dataset.detailsReady === 'true') return;
    root.dataset.detailsReady = 'true';
    root.dataset.mediaUserPaused = 'false';
    const tabs = [...root.querySelectorAll('[role=tab][data-detail-key]')];
    const textPanels = [...root.querySelectorAll('[data-detail-panel]')];
    const mediaPanels = [...root.querySelectorAll('[data-detail-media]')];

    function activate(tab, focus) {
      const key = tab.dataset.detailKey;
      const scrollYBefore = window.scrollY;
      const stableHeight = Math.ceil(root.getBoundingClientRect().height);
      const currentMinimum = parseFloat(root.style.minHeight) || 0;
      if (stableHeight > currentMinimum) root.style.minHeight = stableHeight + 'px';
      tabs.forEach(button => {
        const active = button === tab;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      textPanels.forEach(panel => {
        const active = panel.dataset.detailPanel === key;
        panel.hidden = !active;
        panel.inert = !active;
      });
      mediaPanels.forEach(panel => {
        const active = panel.dataset.detailMedia === key;
        const media = panel.querySelector('[data-feature-media]');
        if (!active) media?._pauseMedia?.();
        panel.hidden = !active;
        panel.inert = !active;
        if (active && media) {
          media._setMediaUserPaused?.(root.dataset.mediaUserPaused === 'true');
          media._restartMedia?.();
          media._playMedia?.(false);
        }
      });
      if (focus) tab.focus({preventScroll:true});
      if (Math.abs(window.scrollY - scrollYBefore) > 1) window.scrollTo({top:scrollYBefore,behavior:'auto'});
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (Math.abs(window.scrollY - scrollYBefore) > 1) window.scrollTo({top:scrollYBefore,behavior:'auto'});
      }));
    }

    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => activate(tab,false));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End','Enter',' '].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Enter' || event.key === ' ') { activate(tab,true); return; }
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(tabs[next],true);
      });
    });
    root.addEventListener('cygnaxis:media-manual', event => {
      root.dataset.mediaUserPaused = String(Boolean(event.detail?.paused));
    });
    const disclosure = root.querySelector('[data-ingredients-disclosure]');
    const disclosureButton = disclosure?.querySelector('[aria-controls]');
    disclosureButton?.addEventListener('click', () => {
      const expanded = disclosureButton.getAttribute('aria-expanded') !== 'true';
      const content = document.getElementById(disclosureButton.getAttribute('aria-controls'));
      disclosureButton.setAttribute('aria-expanded', String(expanded));
      if (content) { content.hidden = !expanded; content.inert = !expanded; }
    });
    activate(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0],false);
  }
  document.querySelectorAll('[data-product-details]').forEach(setup);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
